import { render } from "./jc.vue?vue&type=template&id=5924d9ce&scoped=true"
import script from "./jc.vue?vue&type=script&lang=js"
export * from "./jc.vue?vue&type=script&lang=js"

import "./jc.vue?vue&type=style&index=0&id=5924d9ce&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5924d9ce"]])

export default __exports__